/**
 * @generated SignedSource<<0a674b3cb7a8f8903f0934723577b5ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AssigneeFilterInitialUsersQuery$variables = {
  teamIds?: ReadonlyArray<string | null> | null;
  userIds?: ReadonlyArray<string | null> | null;
};
export type AssigneeFilterInitialUsersQuery$data = {
  readonly teamsById: ReadonlyArray<{
    readonly id: string;
    readonly title: string;
  }> | null;
  readonly usersById: ReadonlyArray<{
    readonly email: string;
    readonly fullName: string;
    readonly id: string;
    readonly image: string;
    readonly isGuest: boolean;
  }> | null;
};
export type AssigneeFilterInitialUsersQuery = {
  response: AssigneeFilterInitialUsersQuery$data;
  variables: AssigneeFilterInitialUsersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userIds"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "userIds",
        "variableName": "userIds"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "usersById",
    "plural": true,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fullName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "image",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isGuest",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "teamIds",
        "variableName": "teamIds"
      }
    ],
    "concreteType": "Team",
    "kind": "LinkedField",
    "name": "teamsById",
    "plural": true,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AssigneeFilterInitialUsersQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AssigneeFilterInitialUsersQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "d921639e93690125f5ab5eec952abcba",
    "id": null,
    "metadata": {},
    "name": "AssigneeFilterInitialUsersQuery",
    "operationKind": "query",
    "text": "query AssigneeFilterInitialUsersQuery(\n  $userIds: [ID]\n  $teamIds: [ID]\n) {\n  usersById(userIds: $userIds) {\n    id\n    email\n    fullName\n    image\n    isGuest\n  }\n  teamsById(teamIds: $teamIds) {\n    id\n    title\n  }\n}\n"
  }
};
})();

(node as any).hash = "6a7916fac361355988db3a1169dbf6de";

export default node;
